import request from "@/utils/request";

export function getUserInfo() {
  return request({
    url: 'api/users/user/userinfo',
    method: 'get'
  })
}

export function getOperateLog(param) {
  return request({
    url: 'api/users/logs/operateloglist',
    method: 'post',
	data:param
  })
}

export function getLoginLog(param) {
  return request({
    url: 'api/users/logs/loginloglist',
    method: 'post',
	data:param
  })
}

export function getAddress() {
  return request({
    url: 'api/users/address/list',
    method: 'post'
  })
}

export function addressSave(param) {
  return request({
    url: 'api/users/address/save',
    method: 'post',
	data:param
  })
}

export function addressInfo(param) {
  return request({
    url: 'api/users/address/info?id='+param,
    method: 'get'
  })
}

export function addressDel(param) {
  return request({
    url: 'api/users/address/del',
    method: 'post',
	data:param
  })
}

export function addressDefault(param) {
  return request({
    url: 'api/users/address/default',
    method: 'post',
	data:param
  })
}

export function siteMassage(param) {
  return request({
    url: 'api/users/sitemsg/list',
    method: 'post',
	data:param
  })
}

export function siteMassageMark(param) {
  return request({
    url: 'api/users/sitemsg/markread',
    method: 'post',
	data:param
  })
}

export function changePwd(param) {
  return request({
    url: 'api/users/secure/changepassword',
    method: 'post',
	data:param
  })
}

export function changeMobile(param) {
  return request({
    url: 'api/users/secure/bindingmobile',
    method: 'post',
	data:param
  })
}

export function changeEmail(param) {
  return request({
    url: 'api/users/secure/bindingemail',
    method: 'post',
	data:param
  })
}

export function weixinFetch(param) {
  return request({
    url: 'api/users/secure/bindingwechat',
    method: 'post',
	data:param
  })
}

export function weixinbind() {
  return request({
    url: 'api/users/secure/confirmbindingwechat',
    method: 'get'
  })
}

export function unbindingwechat(param) {
  return request({
    url: 'api/users/secure/unbindingwechat',
    method: 'post',
	data:param
  })
}

export function securitysetting(param) {
  return request({
    url: 'api/users/secure/securitysetting',
    method: 'post',
	data:param
  })
}

export function checkhasproduct() {
  return request({
    url: 'api/users/cancel/checkhasproduct',
    method: 'post'
  })
}

export function deleteAccountOver() {
  return request({
    url: 'api/users/cancel/deleteover',
    method: 'post'
  })
}

export function getconstinfo(param) {
  return request({
    url: 'api/common/getconstinfo?way='+param,
    method: 'get'
  })
}

export function updateInfo(param) {
  return request({
    url: 'api/users/user/saveinfo',
    method: 'post',
	data:param
  })
}

export function noticeSetting(param) {
  return request({
    url: 'api/users/user/noticesetting',
    method: 'post',
	data: param
  })
}

export function customerServiceInfo() {
  return request({
    url: 'api/users/user/customerserviceinfo',
    method: 'get'
  })
}

export function customerServiceChange(param) {
  return request({
    url: 'api/users/user/customerservicechange',
    method: 'post',
    data: param
  })
}

